import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RrmsServiceLiveDashboardComponent } from './rrms-service-live-dashboard/rrms-service-live-dashboard.component';
import { SmsPdpServiceLiveDashboardComponent } from './sms-pdp-service-live-dashboard/sms-pdp-service-live-dashboard.component';

import { AddRrmsLiveServiceConfigurationComponent } from './add-rrms-live-service-configuration/add-rrms-live-service-configuration.component';
import { AddSmsPdpLiveServiceConfigurationComponent } from './add-sms-pdp-live-service-configuration/add-sms-pdp-live-service-configuration.component';
import { SmsPdpLiveMappingDashboardComponent } from './sms-pdp-live-mapping-dashboard/sms-pdp-live-mapping-dashboard.component';
import { AddSmsPdpLiveMappingConfigurationComponent } from './add-sms-pdp-live-mapping-configuration/add-sms-pdp-live-mapping-configuration.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'rrms-service-live-dashboard',
        component: RrmsServiceLiveDashboardComponent
      },
      {
        path: 'sms-pdp-service-live-dashboard',
        component : SmsPdpServiceLiveDashboardComponent
      },
      {
        path: 'sms-pdp-live-mapping-dashboard',
        component : SmsPdpLiveMappingDashboardComponent
      },
      {
        path: 'add-rrms-service-live',
        component : AddRrmsLiveServiceConfigurationComponent
      },
      {
        path: 'add-sms-pdp-live-service',
        component : AddSmsPdpLiveServiceConfigurationComponent
      },
      {
        path: 'add-sms-pdp-live-mapping',
        component : AddSmsPdpLiveMappingConfigurationComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceLiveDashboardRoutingModule { }
